const initialState = {
  loading: false,
  teams: [],
  teamsByEvent: [],
};

const teamsReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case "GET_TEAMS_DATA": {
      return {
        ...state,
        loading: actions.loading,
        teams: actions.data,
      };
    }
    case "LOADING_TEAM": {
      return {
        ...state,
        loading: actions.loading,
      };
    }
    case "GET_TEAMS_BY_EVENT": {
      return { ...state, teamsByEvent: actions.data, loading: actions.loading };
    }
    case "UPDATE_TEAM": {
      return { ...state, teams: actions.data };
    }
    case "CLEAR_TEAM": {
      return { ...state, teamsByEvent: [] };
    }
    default:
      return state;
  }
};
export default teamsReducer;
